import { SmartTagSystemOperations } from 'tag/ts/smart_tag/operations/SmartTagSystemOperations';
import { SmartTagTagOperations } from 'tag/ts/smart_tag/operations/SmartTagTagOperations';
export class SmartTagOperations {
    #tagOps;
    #systemOps;
    constructor(deps) {
        this.#tagOps = new SmartTagTagOperations(deps);
        this.#systemOps = new SmartTagSystemOperations(deps);
    }
    removeTag = (tag) => this.#tagOps.removeTag(tag);
    resetTags = () => this.#tagOps.resetTags();
    initializeConnectionMonitor = () => this.#systemOps.initializeConnectionMonitor();
    handleAutoplayDetection = () => this.#systemOps.handleAutoplayDetection();
}
